export const MOTORATA_URL = "https://motorata.pl"
export const API_URL = process.env.REACT_APP_API_URL
export const WS_URL = process.env.REACT_APP_WS_URL
